import { motion } from "motion/react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const AnimatedFadeSwitchViewportStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "animated-fade-switch-viewport",
  },
)`
  position: relative;
  flex-grow: 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
`;

export const AnimatedFadeSwitchLayerStyled = styled(
  motion.div,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "animated-fade-switch-layer",
})`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;
